import { ReactNode, useMemo } from "react";
import { FormatOptionLabelMeta } from "react-select";

import { BaseSelect } from "components/v2/Select";
import type { SelectOption } from "components/v2/Select/types";

import {
  buildScacSelectOptions,
  ScacCode,
} from "./trackingScacUtils";

export type TrackingScacSelectProps = Readonly<{
  scacCodes: ScacCode[];
  value: string | null;
  onChange: (value: string | null) => void;
  includeOther?: boolean;
  required?: boolean;
  label?: string;
  placeholder?: string;
  testId?: string;
  isClearable?: boolean;
}>;

function formatScacOptionLabel(option: SelectOption, meta: FormatOptionLabelMeta<SelectOption>): ReactNode {
  if (!option.supportingText || meta.context === "value") {
    return option.label;
  }

  return (
    <>
      <span className="cb-select__option-primary">{option.label}</span>
      <span className="cb-select__option-supporting-text">{option.supportingText}</span>
    </>
  );
}

const TrackingScacSelect = function ({
  scacCodes,
  value,
  onChange,
  includeOther = false,
  required = false,
  label = "SCAC",
  placeholder = "Select",
  testId = "add-tracking-number-scac-select",
  isClearable = false,
}: TrackingScacSelectProps) {
  const options = useMemo(
    () => buildScacSelectOptions(scacCodes, includeOther),
    [includeOther, scacCodes],
  );

  return (
    <div className="mt-3">
      <BaseSelect
        label={label}
        options={options}
        value={value}
        onChange={onChange}
        formatOptionLabel={formatScacOptionLabel}
        menuFitContent
        placeholder={placeholder}
        testId={testId}
        isClearable={isClearable}
        required={required}
      />
    </div>
  );
};

export default TrackingScacSelect;
